<template lang="pug">
  div(id="app")
    router-view
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import "ress/dist/ress.min.css";
import "./assets/scss/global.scss";

export default {
  name: "app",
  computed: {
    ...mapGetters("auth", ["user", "activeCompany"])
  },
  created() {
    const intercomConfig = {
      app_id: "ymuj8q3n"
    };
    if (this.user) {
      Object.assign(intercomConfig, {
        user_id: this.user.id,
        email: this.user.email,
        company: _.get(this.activeCompany, "name")
      });
    }
    // window.Intercom('boot', intercomConfig)
  }
};
</script>

<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.slide-left-fade-enter-active {
  transition: all 0.2s ease;
}

.slide-left-fade-leave-active {
  transition: all 0.2s linear;
}

.slide-left-fade-enter,
.slide-left-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.slide-right-fade-enter-active {
  transition: all 0.2s ease;
}

.slide-right-fade-leave-active {
  transition: all 0.2s linear;
}

.slide-right-fade-enter,
.slide-right-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}
</style>

<style lang="scss">
// @font-face {
//   font-family: "gilroyextrabold";
//   src: url("assets/fonts/gilroy-extrabold-webfont.woff2") format("woff2"),
//     url("assets/fonts/gilroy-extrabold-webfont.woff") format("woff");
//   font-weight: normal;
//   font-style: normal;
// }

// @font-face {
//   font-family: "gilroylight";
//   src: url("assets/fonts/gilroy-light-webfont.woff2") format("woff2"),
//     url("assets/fonts/gilroy-light-webfont.woff") format("woff");
//   font-weight: normal;
//   font-style: normal;
// }

body,
html {
  height: 100%;
  font-family: "gilroylight", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app {
  height: 100%;
}

// overrides

.el-button {
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  border-radius: 2px;
  font-family: "gilroyextrabold";
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 0.05em;
  padding: 0 20px;
  height: 36px;

  &.el-button--primary {
    border: none;
    background-color: #25c4cd;
  }

  &.el-button--secondary {
    background: #e6007e;
  }

  &.el-button--default:hover {
    border-color: #25c4cd;
    color: #25c4cd;
  }
}

.el-table {
  th {
    font-family: "gilroylight";
    text-transform: uppercase;
    font-size: 12px;
  }

  td {
    .el-button--text {
      color: #e6007e;
      font-family: "gilroyextrabold";
      text-transform: uppercase;
    }
  }
}

.el-autocomplete {
  display: block;
}

.el-select {
  display: block;
}

.ql-snow .ql-picker-label::before {
  position: relative;
  top: -7px;
}
</style>
